import React from 'react'
import '../../styles/common/professional-loader.scss'

const ProfessionalLoader = ({ message = 'Loading...', fullScreen = false, showMessage = true, isHiding = false }) => {
  if (fullScreen) {
    return (
      <div className={`professional-loader-overlay ${isHiding ? 'hiding' : ''}`}>
        <div className="loader-content">
          <div className="baseball-loader">
            {/* Baseball Diamond */}
            <div className="diamond"></div>

            {/* Baseball Bat */}
            <div className="bat"></div>

            {/* Animated Baseball */}
            <div className="baseball baseball-image">
              <img src="/baseball.jpg" alt="Loading" />
            </div>

            {/* Home Plate */}
            <div className="home-plate"></div>

            {/* Bases */}
            <div className="base first-base"></div>
            <div className="base second-base"></div>
            <div className="base third-base"></div>
          </div>
          {showMessage && (
            <div className="loading-text">
              <h3>{message}</h3>
              <div className="loading-dots">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="professional-loader-inline">
      <div className="spinner-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {message && <p className="inline-message">{message}</p>}
    </div>
  )
}

export default ProfessionalLoader
